export default class Game {
  constructor (source = {}) {
    Object.assign(this, source)
  }

  get exists () {
    return !!this.id
  }
}
